const app = {
  namespaced: true,
  state: {
    packageVersion: process.env.PACKAGE_VERSION || "0",
  },
  getters: {
    appVersion: (state) => {
      return state.packageVersion
    },
  },
  mutations: {
    refreshVersion(state) {
      state.packageVersion = process.env.PACKAGE_VERSION
    },
  },
  actions: {
    refreshVersion: ({commit}) => {
      commit("refreshVersion")
    },
  },
}

export default app
